import type { DocPageContent } from '../docs-content'

const page = {
  order: 21,
  slug: 'settings',
  title: 'Configuración',
  description:
    'Las pestañas General, Línea de Tiempo, IA y Almacenamiento, además de dónde se establecen el idioma y los accesos directos.',
  category: 'Referencia',
  related: ['keyboard-shortcuts', 'workspaces'],
  sections: [
    {
      title: 'Las cuatro pestañas',
      blocks: [
        {
          kind: 'table',
          headers: ['Pestaña', 'Qué configuras'],
          rows: [
            [
              'General',
              'Auto-guardado activado/desactivado e intervalo (5–30 min); profundidad del historial de deshacer (10–200 pasos); sonidos de interfaz (activado/desactivado, volumen, tema de sonido).',
            ],
            [
              'Línea de Tiempo',
              'Ajuste por defecto; mostrar formas de onda y filmstrips; extraer filmstrips al importar.',
            ],
            ['IA', 'Intervalo de muestreo de subtítulos (segundos o fotogramas); estilo de subtítulo predeterminado.'],
            [
              'Almacenamiento',
              'Generar proxies faltantes; limpiar caché del proyecto; regenerar miniaturas; eliminar proxies; gestionar IA local.',
            ],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Limpiar la caché del proyecto elimina datos regenerados (formas de onda, filmstrips, fotogramas GIF, audio decodificado); nunca elimina los medios fuente. Usa **Restablecer** en el encabezado del diálogo para restaurar los valores predeterminados.',
        },
      ],
    },
    {
      title: 'Sonidos de interfaz',
      blocks: [
        {
          kind: 'paragraph',
          text: 'CachoCut puede reproducir sutiles sonidos de interfaz sintetizados — breves indicaciones que confirman acciones como seleccionar, confirmar, activar/desactivar y eliminar. Están **desactivados por defecto**, son optativos y nunca afectan al audio exportado.',
        },
        {
          kind: 'steps',
          items: [
            'Abre **Configuración** y ve a la pestaña **General**.',
            'Activa **Sonidos de interfaz**.',
            'Ajusta el **Volumen de sonido** a tu gusto (0–100%).',
            'Elige un **Tema de sonido** — **Signature**, **Velvet** o **Crisp** — y usa el botón **Previsualizar** para escucharlo.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Los sonidos se suprimen mientras se reproduce la previsualización, por lo que nunca se filtran en el audio que estás monitorizando; las exportaciones son silenciosas por diseño. Activar el conmutador reproduce una breve confirmación.',
        },
      ],
    },
    {
      title: 'Personalizar los accesos directos del teclado',
      blocks: [
        {
          kind: 'paragraph',
          text: 'Los accesos directos del teclado son totalmente personalizables, pero el editor es un diálogo independiente que se abre desde el botón **Teclado** en la barra de herramientas — no desde este diálogo de Configuración. Dispone de un teclado en pantalla interactivo, búsqueda y filtros **Personalizado** / **Conflictos** / **Sin asignar**, grabación para reasignar, asignaciones alternativas, valores predeterminados por comando y **Restablecer todo**, detección de conflictos, e **Importación** / **Exportación** de preajustes JSON.',
        },
        {
          kind: 'note',
          tone: 'tip',
          text: 'Consulta la página **Accesos directos del teclado** para ver la lista completa de comandos y un tutorial paso a paso para reasignar.',
        },
      ],
    },
    {
      title: 'Configurar en otro lugar',
      blocks: [
        {
          kind: 'list',
          items: [
            'El **idioma** de la interfaz es un control independiente en la barra de herramientas, no forma parte de este diálogo; CachoCut está disponible en 9 idiomas.',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'CachoCut utiliza actualmente un único tema oscuro; no hay selector de temas.',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page